import parse from 'date-fns/parse/index.js';
import { DEFAULT_TIME_FORMAT } from './constants.js';
const dateRe = /(\d+):(\d+) (AM|am|PM|pm)/;
/**
 * Wrapper of `date-fns` `parse` function that is an order of magnitude faster for the `h:mm a` time format we use for
 * restaurant hours, category availability, etc.
 *
 * @param time The string to parse.
 * @param targetTimeFormat The string of tokens.
 * @param relativeTo Defines values missing from the parsed time.
 */
export function fastParse(time, targetTimeFormat, relativeTo) {
    if (targetTimeFormat !== DEFAULT_TIME_FORMAT) {
        return parse(time, targetTimeFormat, relativeTo);
    }
    const res = time.match(dateRe);
    if (!res || res.length < 4)
        throw new Error('Invalid time format: ' + time);
    const [hour, minute, ampm] = res.slice(1);
    const offset = 
    // 12 am is 0 (-12), 12 pm is 12 (0), other pm is +12, other am is 0
    hour === '12'
        ? ampm.toUpperCase() === 'PM'
            ? 0
            : -12
        : ampm.toUpperCase() === 'PM'
            ? 12
            : 0;
    const out = new Date(relativeTo);
    out.setHours(Number(hour) + offset, Number(minute), 0, 0);
    return out;
}
//# sourceMappingURL=fastParse.js.map